import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { ID } from '@/utils/enums';
import { cn } from '@/utils/helper';
import v1 from '@/components/quiz/components/quiz-head/quiz-head-v1.module.css';
import v2 from '@/components/quiz/components/quiz-head/quiz-head-v2.module.css';

const QuizHead = () => {
  const dialog = useAppSelector(ConfigSlice.selectors.additionalQuestions);

  if (!dialog) return null;

  return (
    <div id={ID.QUIZ_HEADER} className={cn(v1.QuizHead, v2.QuizHead)}>
      {dialog.header()}
    </div>
  );
};

export default QuizHead;
